import { render, staticRenderFns } from "./ModalDialog-Confirm.vue?vue&type=template&id=33e47824&"
import script from "./ModalDialog-Confirm.vue?vue&type=script&lang=js&"
export * from "./ModalDialog-Confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports